module.exports = __webpack_public_path__ + "static/img/10004 (1).a86d6fe.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10004 (1).webp
// module id = N9KV
// module chunks = 14